import { useDispatch } from "react-redux";
import { useCallback } from "react";
import styled from "styled-components";
import { Button } from "components";
import { Header } from "layout/ModalWindow/layout";
import { closeModal } from "layout";

interface ProctorInfoModalProps {
	name: string;
	onConfirm?: () => void;
}

const ProctorInfoModal = ({ onConfirm }: ProctorInfoModalProps) => {
	const dispatch = useDispatch();

	const handleClose = useCallback(() => {
		dispatch(closeModal("ProctorInfoModal"));
	}, [dispatch]);

	const handleConfirm = useCallback(() => {
		if (onConfirm) {
			onConfirm();
		}
		handleClose();
	}, [onConfirm, handleClose]);

	return (
		<Container>
			<Header onClose={handleClose} />
			<Content>
				<Title>Экзамен с прокторингом</Title>
				
				<Description>
					Для сдачи официального экзамена необходимо пройти процедуру 
					прокторинга — дистанционного контроля за ходом экзамена.
				</Description>

				<Section>
					<SectionTitle>Что потребуется:</SectionTitle>
					<List>
						<ListItem>Паспорт гражданина РФ</ListItem>
						<ListItem>Веб-камера (встроенная или внешняя)</ListItem>
						<ListItem>Микрофон</ListItem>
						<ListItem>Стабильное интернет-соединение</ListItem>
						<ListItem>Отдельное помещение без посторонних</ListItem>
					</List>
				</Section>

				<Section>
					<SectionTitle>Правила проведения:</SectionTitle>
					<List>
						<ListItem>Во время экзамена ведётся видеозапись</ListItem>
						<ListItem>Нельзя отводить взгляд от экрана</ListItem>
						<ListItem>Нельзя пользоваться подсказками</ListItem>
						<ListItem>В кадре должно быть только ваше лицо</ListItem>
					</List>
				</Section>

				<Warning>
					Нарушение правил может привести к аннулированию результата экзамена.
				</Warning>

				<ButtonsContainer>
					<Button buttonTheme="secondary" onClick={handleClose}>
						Отмена
					</Button>
					<Button onClick={handleConfirm}>
						Понятно, продолжить
					</Button>
				</ButtonsContainer>
			</Content>
		</Container>
	);
};

export default ProctorInfoModal;

const Container = styled.div`
	background: #fff;
	border-radius: 16px;
	max-width: 520px;
	width: 100%;
	max-height: 90vh;
	overflow-y: auto;
`;

const Content = styled.div`
	padding: 0 32px 32px;
`;

const Title = styled.h2`
	font-size: 1.5rem;
	font-weight: 600;
	text-align: center;
	margin: 0 0 16px;
	color: #1a1a1a;
`;

const Description = styled.p`
	text-align: center;
	color: #666;
	line-height: 1.6;
	margin-bottom: 24px;
`;

const Section = styled.div`
	margin-bottom: 20px;
`;

const SectionTitle = styled.h3`
	font-size: 1rem;
	font-weight: 600;
	margin: 0 0 12px;
	color: #1a1a1a;
`;

const List = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0;
`;

const ListItem = styled.li`
	position: relative;
	padding-left: 24px;
	margin-bottom: 8px;
	color: #333;
	font-size: 0.95rem;
	line-height: 1.4;

	&::before {
		content: "•";
		position: absolute;
		left: 8px;
		color: #007bff;
	}
`;

const Warning = styled.div`
	background: #fff3cd;
	border: 1px solid #ffc107;
	border-radius: 8px;
	padding: 12px 16px;
	margin-bottom: 24px;
	font-size: 0.9rem;
	color: #856404;
	text-align: center;
`;

const ButtonsContainer = styled.div`
	display: flex;
	gap: 12px;
	justify-content: center;

	button {
		min-width: 140px;
	}
`;






